import styled from 'styled-components' 

export const Background = styled.img`
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0.7;
    top: 0;
    left: 0;
    right: 0;

    background-image: ${({ backgroundImage }) => `url(${backgroundImage})`}; 
    background-size: cover;
    
    @media only screen and (max-device-width: 800px) {
        width: 100%;
    }
`


